// extracted by mini-css-extract-plugin
export var container = "_h9-0";
export var content = "_h9-3";
export var customerTitle = "_h9-4";
export var empty = "_h9-5";
export var gray = "_h9-6";
export var header = "_h9-7";
export var info = "_h9-8";
export var loading = "_h9-2";
export var loadingCard = "_h9-9";
export var oneLine = "_h9-a";
export var personName = "_h9-e";
export var pillContainer = "_h9-b";
export var selected = "_h9-1";
export var text = "_h9-c";
export var twoLines = "_h9-d";
export var unread = "_h9-f";
export var unreadIndicator = "_h9-g";